import { StyledEngineProvider } from '@mui/material';
import ReactDOM from 'react-dom/client';
import './lib/style/index.scss';
import './index.css';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import App from './App';
import { AuthProvider } from './components/auth-guard/JWTContext';
import { SettingsProvider } from './context/SettingsContext';
import { store } from './store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ReduxProvider store={ store }>
        <StyledEngineProvider>
            <SettingsProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <App />
                    </AuthProvider>
                </BrowserRouter>
            </SettingsProvider>
        </StyledEngineProvider>
    </ReduxProvider>,
);
